module.exports = __webpack_public_path__ + "img/biaoqian123x.42ac49e3.png";